import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBell, FiSearch } from 'react-icons/fi';

const Header = () => {
  return (
    <header className="h-16 border-b border-slate-800 bg-slate-900/50 backdrop-blur-md flex items-center justify-between px-6 sticky top-0 z-10">
      <div className="flex items-center bg-slate-800/40 border border-slate-700/50 rounded-full px-4 py-1.5 w-96 focus-within:border-amber-500/30 focus-within:ring-1 focus-within:ring-amber-500/20 transition-all">
        <SafeIcon icon={FiSearch} className="text-slate-500 mr-2" />
        <input 
          type="text" 
          placeholder="Search controls, evidence, policies..." 
          className="bg-transparent border-none outline-none text-sm text-slate-300 w-full placeholder-slate-600" 
        />
      </div>
      
      <div className="flex items-center gap-4">
        <button className="relative p-2 text-slate-400 hover:text-amber-400 transition-colors bg-slate-800/50 rounded-lg border border-slate-700/50">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-amber-500 rounded-full border-2 border-slate-900 shadow-[0_0_8px_rgba(245,158,11,0.5)]"></span>
        </button>
        
        <div className="flex items-center gap-3 pl-4 border-l border-slate-800">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-bold text-slate-200 leading-none">Admin User</p>
            <p className="text-[10px] text-amber-500 font-bold uppercase tracking-widest mt-1">Acme Global</p>
          </div>
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center border border-slate-600 text-amber-500 font-bold shadow-inner">
            AD
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;